import React, { Component } from "react";
import apiContext from "../../api";
import { redirect } from "components/Layout/Page/Page";
import "./Finances.scss";

import Modal from "components/Surfaces/Modal/Modal";

import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EmptyDataInvoiceImage from "../../assets/illustrations/empty-data-invoice.png";
import InvoiceImage from "../../assets/illustrations/invoice.png";
import CardFinance from "components/DataDisplay/CardFinance/CardFinance";
import ConsumptionModal from "components/DataDisplay/ConsumptionModal/ConsumptionModal";
import MonthlyTicketsLineChart, {
  getTicketsChartData,
  reduceMonths,
} from "components/DataDisplay/MonthlyTicketsLineChart/MonthlyTicketsLineChart";
import TicketModal from "components/DataDisplay/TicketModal/TicketModal";
import { IconFilter } from "components/Icons/IconFilter";
import { IconFilterActive } from "components/Icons/IconFIlterActive";
import { IconSpinner } from "components/Icons/Icons";
import { IconSearchNF } from "components/Icons/IconSearchNF";
import ModalFinance from "components/DataDisplay/ModalFinance/ModalFinance";
import ModalRedirect from "components/DataDisplay/ModalRedirect/ModalRedirect";
import { getMonthLabel } from "components/DataDisplay/MonthlyConsumptionLineChart/MonthlyConsumptionLineChart";
import NavigationBar from "components/Navigation/NavigationBar/NavigationBar";
import NewSearch from "components/Inputs/NewSearch/NewSearch";
import NewSwitch from "components/Inputs/NewSwitch/NewSwitch";
import ClienteService from "../../services/cliente";
import CondominioService from "../../services/condominio";
import InvoiceService from "../../services/invoice";
import TicketService from "../../services/ticket";
import { loadingOperations } from "../../state/ducks/loading";
import { toastOperations } from "../../state/ducks/toast";
import HomeTemplate from "../HomeTemplate/HomeTemplate";
import AcquittanceTabComponent from "./AcquittanceTabComponent";
import EmissionBlockedModal from "./EmissionBlockedModal";
import TicketFilterModal from "./TicketFilterModal";

const LoadingLine = () => (
  <p className="text-center">
    <IconSpinner color="#000" style={{ animation: "1s infinite spin" }} />
  </p>
);

function mapDispatchToPropsAcquittance(dispatch) {
  return bindActionCreators(
    {
      showLoading: loadingOperations.show,
      dismissLoading: loadingOperations.dismiss,
    },
    dispatch
  );
}

const AcquittanceTab = connect(
  null,
  mapDispatchToPropsAcquittance
)(AcquittanceTabComponent);

class Finances extends Component {
  static contextType = apiContext;

  constructor(props) {
    super(props);
    const {
      location: { state: locationState },
    } = this.props;

    let tab = "invoices";
    if (props.location && props.location.state && this.props.location.state.tab)
      tab = this.props.location.state.tab;

    this.state = {
      invoiceModalData: null,
      ticketModalData: null,
      showTicketFilterModal:
        ((locationState || {}).selectedStatus || []).length === 0,
      showSearch: false,
      tab,
      selectedCondominio: CondominioService.selectAll
        ? "all"
        : CondominioService.selected || {},
      ticketFilters: this.initialFilters,
      filtersActive: false,
      showModalFinance: false,
    };
  }

  get initialFilters() {
    const {
      location: { state: locationState },
    } = this.props;
    return {
      selectedStatus: (locationState || {}).selectedStatus || [],
      selectedProduct: "todos",
      selectedUnits: [],
      selectedAddress: "todos",
      selectedAddresses: [],
      selectedInitialDate: "",
      selectedLastDate: "",
      selectedCondominio: CondominioService.selectAll
        ? "all"
        : CondominioService.selected || {},
    };
  }

  hasActiveFilters = () => {
    const { ticketFilters } = this.state;

    if (ticketFilters.selectedStatus && ticketFilters.selectedStatus.length > 0)
      return true;
    if (
      ticketFilters.selectedInitialDate &&
      ticketFilters.selectedInitialDate !== ""
    )
      return true;
    if (ticketFilters.selectedLastDate && ticketFilters.selectedLastDate !== "")
      return true;

    return false;
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.ticketFilters !== this.state.ticketFilters) {
      const active = this.hasActiveFilters();

      this.setState({ filtersActive: active ? true : false });
    }
  }

  async componentDidMount() {
    const { segmento } = ClienteService.localEntrega;

    if (segmento === "CONTASIM") {
      await this.getDataForIndustrial();
    }

    if (segmento === "INDUSTRIAL" || segmento === "LICITACAO") {
      await this.getDataForContaSim();
      await this.getDataForIndustrial();
    }
  }

  handleNfJoin() {
    let { tickets, invoices } = this.state;

    const { "local-entrega": localEntrega } = CondominioService.selected || {};

    if (!invoices || !tickets) {
      this.setState({ tickets: tickets || [] });
    }

    const joined = tickets
      ?.filter((ticket) => {
        const local = String(ticket["local-entrega"])
          .replace(`ã`, `a`)
          .replace("Ã", "A")
          .toLowerCase();
        let localDelivery = String(localEntrega)
          .replace(`ã`, `a`)
          .replace("Ã", "A")
          .toLowerCase();
        if (localEntrega) return local === localDelivery;
        return true;
      })
      .map((ticket) => {
        let invoice = {};
        if (Array.isArray(invoices)) {
          const invoicesFiltred = invoices.filter(
            (invoice) =>
              ticket["nr-nota-fis"] === invoice["cod_tit_acr"] &&
              ticket["serie"] === invoice["cod_ser_docto"]
          );
          invoice = invoicesFiltred[0] || {};
        }
        return { ...ticket, ...invoice, invoices };
      });

    this.setState({ tickets: joined || [] });
  }

  getDataForContaSim() {
    const { CPFCNPJ } = ClienteService.localEntrega || {};
    const { [`local-entrega`]: localEntrega } =
      CondominioService.selected || {};

    const dataFim = new Date();
    const dataIni = new Date();
    dataIni.setFullYear(dataFim.getFullYear() - 1);

    return this.context.ConsigazApi.memConsultaSegundaViaBoleto(
      CPFCNPJ,
      this.context.ConsigazApi.formatDate(dataIni),
      this.context.ConsigazApi.formatDate(dataFim),
      localEntrega || ""
    )
      .then(({ dsRetorno }) => {
        if (JSON.stringify(dsRetorno) === "{}" || !dsRetorno) return;

        if (
          !dsRetorno ||
          !Object.prototype.hasOwnProperty.call(
            dsRetorno,
            "tt-cliente-retorno"
          ) ||
          !Array.isArray(dsRetorno["tt-cliente-retorno"])
        ) {
          this.setState({ invoices: [] });
        }

        const invoices = [...dsRetorno["tt-cliente-retorno"]].reverse();
        this.setState({ invoices }, () => {
          this.handleNfJoin();
        });
        console.log(invoices);
      })
      .catch((errorDescription) =>
        this.props.showToast("Ops!", errorDescription)
      );
  }

  getDataForIndustrial() {
    const { CPFCNPJ } = ClienteService.localEntrega;

    const { [`local-entrega`]: localEntrega } =
      this.state.selectedCondominio || {};

    const dataFim = new Date();
    const dataIni = new Date();
    dataIni.setFullYear(dataFim.getFullYear() - 1);

    return this.context.ConsigazApi.memConsultaNotaFiscal(
      CPFCNPJ,
      this.context.ConsigazApi.formatDate(dataIni),
      this.context.ConsigazApi.formatDate(dataFim),
      localEntrega
    )
      .then(({ Notas }) => {
        if (
          !Notas ||
          !Object.prototype.hasOwnProperty.call(Notas, "NotasFiscais") ||
          !Array.isArray(Notas.NotasFiscais)
        ) {
          this.setState({ tickets: [] });
        }

        this.setState(
          {
            tickets: Notas?.NotasFiscais,
            chartCenterIdx: Notas?.NotasFiscais?.length - 1,
            invoiceInFocus:
              Notas?.NotasFiscais?.[Notas?.NotasFiscais?.length - 1],
          },
          () => this.handleNfJoin()
        );
      })
      .catch((errorDescription) =>
        this.props.showToast("Ops!", errorDescription)
      );
  }

  getInvoiceStyle(invoiceData) {
    const status = InvoiceService.getInvoiceStatus(invoiceData);
    return {
      paid: "toplineSuccess",
      outdated: "toplineDanger",
      open: "toplineWarning",
    }[status];
  }

  static getTicketStyle(ticketData) {
    const status = TicketService.getTicketStatus(ticketData);
    return {
      paid: "toplineSuccess",
      outdated: "toplineDanger",
      open: "toplineWarning",
      cancel: "toplineCancel",
    }[status];
  }

  handleAcquittanceLetter = ({ type, year, company, cartaBase64 }) => {
    this.setState(
      {
        cartaBase64,
        typeAcquittance: type,
        yearAcquittance: year,
        companyAcquittance: company,
      },
      () => this.modalAcquittanceLetter && this.modalAcquittanceLetter.open()
    );
  };

  filterTicketsByTab = (ticketsFiltered, tab) => {
    let ticketsByTab = ticketsFiltered;

    if (tab === "open-invoices") {
      ticketsByTab = ticketsFiltered.filter((ticket) => {
        const status = TicketService.getTicketStatus(ticket);
        return ["avencer", "outdated", "open"].includes(status);
      });
    }

    return ticketsByTab;
  };

  sendAcquittanceLetter = () => {
    const { typeAcquittance, yearAcquittance } = this.state;
    const { CPFCNPJ, email } = ClienteService.localEntrega || {};

    this.context.ConsigazApi.sendEmail(
      CPFCNPJ,
      "Consigaz",
      typeAcquittance === "total" ? 9999 : yearAcquittance
    ).then(
      () =>
        this.props.showToast(
          "Enviado!",
          `Carta de quitação enviada para ${email}`
        ),
      () => this.props.showToast("Ops!", `Erro ao enviar a carta de quitação`)
    );
  };

  renderInvoiceList() {
    const { invoices, tab } = this.state;

    let invoiceListFilter = () => true;
    if (tab === "open-invoices")
      invoiceListFilter = (inv) => inv["val_sdo_tit_acr"] !== 0;

    const invoicesFiltered = (invoices || []).filter(invoiceListFilter);

    if (!!invoicesFiltered && invoicesFiltered.length)
      return invoicesFiltered.map((invoice, idx) => (
        <CardFinance
          key={idx}
          ticket={invoice}
          onClick={() => {
            this.setState({
              ticketModalData: invoice,
              showModalFinance: true,
            });
          }}
        />
      ));
    else if (invoices.length === 0)
      return (
        <Stack justifyContent={"center"} alignItems={"center"} gap={2}>
          <IconSearchNF />
          <Typography fontSize={"16px"} fontWeight={700} color="#053462">
            Nenhuma nota fiscal à exibir.
          </Typography>
        </Stack>
      );
  }

  handleFilters() {
    const { tickets, ticketFilters, selectedCondominio } = this.state;
    let ticketListFilter = () => true;

    const ticketsFiltered = (tickets || [])
      .filter(ticketListFilter)
      .filter((ticket) => {
        if (selectedCondominio !== "all")
          return (
            selectedCondominio["endereco"].indexOf(ticket["endereco"]) > -1
          );
        else return true;
      });

    const filterInitialDate =
      ticketFilters["selectedInitialDate"] &&
      moment(ticketFilters["selectedInitialDate"], "DD/MM/YYYY");
    const filterLastDate =
      ticketFilters["selectedLastDate"] &&
      moment(ticketFilters["selectedLastDate"], "DD/MM/YYYY");

    const filterList = ticketsFiltered
      .filter((ticket) => {
        if (ticketFilters["selectedStatus"].length !== 0)
          return (
            ticketFilters["selectedStatus"].indexOf(
              TicketService.getTicketStatus(ticket)
            ) > -1
          );
        else return ticket;
      })
      .filter((ticket) => {
        return (ticket.Itens || []).some((item) => {
          if (ticketFilters["selectedProduct"] === "granel")
            return item.un.toLowerCase() === "kg";
          else if (ticketFilters["selectedProduct"] === "todos") return ticket;
          else if (
            ticketFilters["selectedProduct"] === "cilindros" &&
            ticketFilters["selectedUnits"].length === 0
          )
            return item.un.toLowerCase() === "un";
          else if (ticketFilters["selectedUnits"].length > 0)
            return (
              ticketFilters["selectedUnits"].indexOf(
                item["it-codigo"].toLowerCase()
              ) > -1
            );
          else return null;
        });
      })
      .filter((ticket) => {
        if (ticketFilters["selectedAddress"] !== "todos")
          return (
            ticketFilters["selectedAddresses"].indexOf(ticket["endereco"]) > -1
          );
        else return ticket;
      })
      .filter((ticket) => {
        if (filterInitialDate !== "Data inválida") {
          const ticketDate = moment(ticket["dt-emis-nota"], "YYYY-MM-DD");
          return (
            !filterInitialDate || ticketDate.isSameOrAfter(filterInitialDate)
          );
        } else return ticket;
      })
      .filter((ticket) => {
        if (filterLastDate !== "Data inválida") {
          const ticketDate = moment(ticket["dt-emis-nota"], "YYYY-MM-DD");
          return !filterLastDate || ticketDate.isSameOrBefore(filterLastDate);
        } else return ticket;
      });

    return filterList;
  }

  goToHelp = () => {
    redirect(this.props, "/help");
  };

  renderTicketList() {
    const { tickets, ticketFilters, selectedCondominio, selectedNF, tab } =
      this.state;

    let ticketListFilter = () => true;

    const ticketsFiltered = (tickets || [])
      .filter(ticketListFilter)
      .filter((ticket) => {
        if (selectedCondominio !== "all") {
          return (
            selectedCondominio["endereco"].indexOf(ticket["endereco"]) > -1
          );
        } else {
          return true;
        }
      });

    let ticketsByTab = this.filterTicketsByTab(ticketsFiltered, tab);

    // Sempre filtra as notas fiscais pelo número digitado
    const ticketFilterSearch = (ticketsByTab || []).filter(
      (ticket) => ticket["nr-nota-fis"].indexOf(selectedNF) > -1
    );

    const { segmento } = ClienteService.localEntrega;

    return (
      <>
        {(segmento === "INDUSTRIAL" || segmento === "LICITACAO") && (
          <Stack direction="row" spacing={2} alignItems={"center"} mb={"75px"}>
            <NewSearch
              value={selectedNF}
              onChange={(e) => this.setState({ selectedNF: e.target.value })}
              placeholder={"Número da nota fiscal"}
              width={"100%"}
            />
            <Stack>
              <IconButton
                onClick={() => {
                  this.setState({ showTicketFilterModal: true });
                }}
                sx={{ padding: "0px" }}
              >
                {this.state.filtersActive ? (
                  <IconFilterActive />
                ) : (
                  <IconFilter />
                )}
              </IconButton>
              <Typography
                fontSize="11px"
                fontWeight={600}
                color="#053462"
                mb={1.3}
              >
                Filtros
              </Typography>
            </Stack>
          </Stack>
        )}

        {selectedNF && selectedNF.trim() !== "" ? (
          ticketFilterSearch && ticketFilterSearch.length ? (
            ticketFilterSearch.map((ticket, idx) => (
              <CardFinance
                key={idx}
                ticket={ticket}
                onClick={() => {
                  this.setState({
                    ticketModalData: ticket,
                    showModalFinance: true,
                  });
                }}
              />
            ))
          ) : (
            <Stack justifyContent={"center"} alignItems={"center"} gap={2}>
              <IconSearchNF />
              <Typography fontSize={"16px"} fontWeight={700} color="#053462">
                Nenhuma nota fiscal à exibir.
              </Typography>
            </Stack>
          )
        ) : ticketFilters != null ? (
          (() => {
            let filteredList = this.handleFilters();

            filteredList = this.filterTicketsByTab(filteredList, tab);

            return filteredList.length > 0 ? (
              filteredList.map((ticket, idx) => (
                <CardFinance
                  key={idx}
                  ticket={ticket}
                  onClick={() => {
                    this.setState({
                      ticketModalData: ticket,
                      showModalFinance: true,
                    });
                  }}
                />
              ))
            ) : (
              <Stack justifyContent={"center"} alignItems={"center"} gap={2}>
                <IconSearchNF />
                <Typography fontSize={"16px"} fontWeight={700} color="#053462">
                  Nenhuma nota fiscal à exibir.
                </Typography>
              </Stack>
            );
          })()
        ) : // Se não houver filtro de busca nem filtros aplicados, renderiza a lista padrão
        ticketsByTab.length > 0 ? (
          ticketsByTab.map((ticket, idx) => (
            <CardFinance
              key={idx}
              ticket={ticket}
              onClick={() => {
                this.setState({
                  ticketModalData: ticket,
                  showModalFinance: true,
                });
              }}
            />
          ))
        ) : (
          <div>
            <img
              src={EmptyDataInvoiceImage}
              alt="Empty data placeholder"
              height={100}
            />
            <p>Aqui você visualizará as suas notas fiscais</p>
          </div>
        )}
      </>
    );
  }

  getChartData(shouldSlice = true) {
    const { tickets, ticketFilters } = this.state;
    const { endereco } = CondominioService.selected || {};

    return getTicketsChartData(
      endereco
        ? tickets.filter((t) => endereco.indexOf(t.endereco) > -1)
        : tickets,
      this.chartCenterIdx,
      ticketFilters,
      shouldSlice,
      "valor"
    );
  }

  get chartCenterIdx() {
    const { chartData } = this.state;
    let { chartCenterIdx } = this.state;

    if (chartData && chartCenterIdx > chartData.length)
      chartCenterIdx = parseInt(chartData.length / 2);

    return chartCenterIdx;
  }

  getChartCenterItem(chartData) {
    const chartCenterIdx = this.chartCenterIdx;

    return chartData && chartData.length && chartData[chartCenterIdx];
  }

  renderChartWithTicketData() {
    const { tickets, ticketFilters } = this.state;

    const chartData = this.getChartData();

    const monthReducedTickets = reduceMonths(tickets);

    return (
      <>
        <div className="chart">
          {chartData.length ? (
            <>
              <p className="title">
                {Object.keys(monthReducedTickets).length === 1
                  ? "Pagamento do último mês"
                  : `Pagamentos últimos ${
                      Object.keys(monthReducedTickets).length
                    } meses`}
              </p>
              <button
                className="rectangle"
                style={{ position: "absolute", right: "1rem", top: "1rem" }}
                onClick={() => {
                  this.setState({ showTicketFilterModal: true });
                }}
              >
                Alterar filtros
              </button>
              <div className="chart-container">
                <MonthlyTicketsLineChart
                  data={chartData}
                  filters={ticketFilters}
                  chartReference={this.state.chartReference}
                  valueBase="valor"
                />
              </div>
              <NavigationBar
                tabs={chartData.map((month) => ({
                  value: month,
                  label: getMonthLabel(month),
                  active: month.selected,
                  onClick: () =>
                    this.setState({
                      chartCenterIdx: month.itemIdx,
                      invoiceInFocus: month,
                    }),
                }))}
                defineActive={true}
              />
            </>
          ) : (
            <p className="text-center">
              <img
                src={EmptyDataInvoiceImage}
                alt="Empty chart placeholder"
                height={100}
              />
              <br />
              Aqui você visualizará o gráfico com os seus pagamentos
            </p>
          )}
        </div>
      </>
    );
  }

  openDocument = () => {
    const base64String = this.state.cartaBase64;

    const binaryString = atob(base64String);

    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes.buffer], { type: "application/pdf" });

    const url = URL.createObjectURL(blob);
    window.open(url);
  };

  renderAcquittanceLetter() {
    const { yearAcquittance, typeAcquittance } = this.state;
    return (
      <>
        <AcquittanceTab
          onSubmit={this.handleAcquittanceLetter}
          onOpenInvoices={() =>
            this.modalAcquittanceLetterOps &&
            this.modalAcquittanceLetterOps.open()
          }
        />
        <Modal
          shown={false}
          ref={(ref) => (this.modalAcquittanceLetterOps = ref)}
          closeButton={true}
          className="carta-quitacao-ops-modal"
          title="Ops!"
        >
          Sua carta ainda não pode ser emitida. Existem débitos em aberto no
          período selecionado. Regularize sua situação!
          <footer className="text-center">
            <button
              className="block"
              onClick={() =>
                this.setState(
                  { tab: "open-invoices" },
                  () =>
                    this.modalAcquittanceLetterOps &&
                    this.modalAcquittanceLetterOps.close()
                )
              }
            >
              Regularizar débitos
            </button>
          </footer>
        </Modal>
        <Modal
          shown={false}
          ref={(ref) => (this.modalAcquittanceLetter = ref)}
          closeButton={true}
          className="carta-quitacao-modal"
          title={
            typeAcquittance === "anual"
              ? `Carta Anual ${yearAcquittance}`
              : `Carta Total`
          }
        >
          <img
            src={InvoiceImage}
            alt="Invoice Illustration"
            height={150}
            onClick={() => this.openDocument()}
          />

          <div className="text-center">
            <button
              className="link secondary"
              onClick={() => this.openDocument()}
            >
              Clique na imagem para visualizar
            </button>
          </div>

          <footer className="text-center">
            <button
              onClick={this.sendAcquittanceLetter}
              className="link secondary"
            >
              Compartilhar por email
            </button>
          </footer>
        </Modal>
      </>
    );
  }

  renderButton() {
    const { showSearch, tickets, selectedCondominio } = this.state;
    let ticketListFilter = () => true;

    const ticketsFiltered = (tickets || [])
      .filter(ticketListFilter)
      .filter((ticket) => {
        if (selectedCondominio !== "all")
          return (
            selectedCondominio["endereco"].indexOf(ticket["endereco"]) > -1
          );
        else return tickets;
      });

    return (
      <>
        {ticketsFiltered.length ? (
          <>
            <h1>Encontre notas fiscais</h1>
            {showSearch === false ? (
              <button
                className="rectangle"
                style={{ marginRight: "5px" }}
                onClick={() => {
                  this.setState({ showTicketFilterModal: true });
                }}
              >
                Alterar filtros
              </button>
            ) : (
              ""
            )}
            <button
              className="rectangle"
              onClick={() => {
                if (showSearch === false) this.setState({ showSearch: true });
                else this.setState({ showSearch: false });
              }}
            >
              {showSearch === true
                ? "Visualizar todas notas"
                : "Buscar NF pelo número"}
            </button>
            <br />
          </>
        ) : (
          ""
        )}
      </>
    );
  }

  render() {
    const { ticketModalData, tab, tickets, showTicketFilterModal } = this.state;
    const { segmento } = ClienteService.localEntrega || {};
    const {
      location: { state: locationState },
    } = this.props;

    const tabsData = [
      { id: "invoices", label: "Notas Fiscais" },
      { id: "graphics", label: "Gráfico de Pagamentos", showSearch: false },
      { id: "acquittance-letter", label: "Carta de quitação" },
    ];

    const tabsDataCpf = [
      { id: "invoices", label: "Todas" },
      { id: "open-invoices", label: "Em aberto" },
      { id: "acquittance-letter", label: "Carta de quitação" },
    ];

    const handleChangeTab = (tabItem) => {
      this.setState({ tab: tabItem.id });
      if (Object.prototype.hasOwnProperty.call(tabItem, "showSearch")) {
        this.setState({ showSearch: tabItem.showSearch });
      }
    };
    if (segmento === "CONTASIM") {
      return (
        <HomeTemplate
          ref={(ref) => (this.template = ref)}
          history={this.props.history}
          activeTab="Financeiro"
          className="finances-page"
        >
          <Stack p={"0px 82px"}>
            <NewSwitch
              tabsData={tabsDataCpf}
              currentTab={tab}
              onChangeTab={handleChangeTab}
            />
            <Stack alignItems={"center"} mt={"42px"}>
              {(tab === "invoices" || tab === "open-invoices") && (
                <>{(tickets && this.renderTicketList()) || <LoadingLine />}</>
              )}
            </Stack>
          </Stack>

          {tab === "acquittance-letter" && this.renderAcquittanceLetter()}
          <ModalFinance
            ref={(ref) => (this.modalFinance = ref)}
            open={this.state.showModalFinance}
            onClose={() => this.setState({ showModalFinance: false })}
            ticket={this.state.ticketModalData}
          />
        </HomeTemplate>
      );
    } else {
      return (
        <HomeTemplate
          ref={(ref) => (this.template = ref)}
          history={this.props.history}
          activeTab="Financeiro"
          className="finances-page"
        >
          <Stack p={"0px 82px"}>
            <NewSwitch
              tabsData={tabsData}
              currentTab={tab}
              onChangeTab={handleChangeTab}
            />
          </Stack>
          <br />
          {tab === "acquittance-letter" && this.renderAcquittanceLetter()}
          <Stack p={"0px 82px"}>
            {(tab === "invoices" || tab === "open-invoices") && (
              <>{tickets ? <>{this.renderTicketList()}</> : <LoadingLine />}</>
            )}
          </Stack>

          {tab === "graphics" && (
            <>
              {(tickets && this.renderChartWithTicketData()) || <LoadingLine />}
              <br />
            </>
          )}
          <ModalFinance
            ref={(ref) => (this.modalFinance = ref)}
            open={this.state.showModalFinance}
            onClose={() => this.setState({ showModalFinance: false })}
            ticket={this.state.ticketModalData}
          />

          <TicketModal
            ref={(ref) => (this.modalNotaFiscal = ref)}
            template={this.template}
            ticketData={ticketModalData}
            onCopy={() => this.modalNotaFiscal && this.modalNotaFiscal.close()}
          />
          <ConsumptionModal
            ref={(ref) => (this.modalDetalhes = ref)}
            history={this.props.history}
            ticketData={ticketModalData}
            onShowInvoice={() => {
              this.modalDetalhes && this.modalDetalhes.close();
              this.modalNotaFiscal && this.modalNotaFiscal.open();
            }}
          />

          <TicketFilterModal
            ref={(ref) => (this.ticketFilterModalRef = ref)}
            selectedStatus={(locationState || {}).selectedStatus || []}
            shown={tab !== "acquittance-letter" && showTicketFilterModal}
            statusData={Object.values(reduceMonths(tickets || [])).reduce(
              (reducedStatus, month) => {
                (month || []).forEach((ticket) => {
                  (ticket.Duplicatas || []).forEach((duplicata) => {
                    const key = duplicata["nr-nota-fis"];
                    reducedStatus[key] = duplicata["situacao"];
                  });
                });
                return reducedStatus;
              },
              {}
            )}
            productsData={Object.values(reduceMonths(tickets || [])).reduce(
              (reduced, month) => {
                (month || []).forEach((ticket) => {
                  (ticket.Itens || []).forEach((item) => {
                    const key = item["it-codigo"].toLowerCase();
                    reduced[key] = item;
                  });
                });
                return reduced;
              },
              {}
            )}
            addressData={Object.values(reduceMonths(tickets || [])).reduce(
              (reduced, month) => {
                (month || []).forEach((ticket) => {
                  const key = `${ticket.endereco}, ${ticket.cidade}, ${ticket.estado}`;
                  if (reduced.indexOf(key) === -1) reduced.push(key);
                });
                return reduced;
              },
              []
            )}
            onSubmit={(filters) => {
              if (
                this.chartFilterModalRef &&
                this.chartFilterModalRef.showProductsFilter &&
                filters.selectedProduct !== "granel" &&
                filters.selectedUnits.length <= 0
              ) {
                this.props.showToast(
                  "Ops",
                  "Para prosseguir, selecione o(s) tipo(s) de produto(s) desejado(s)"
                );
              } else {
                this.setState({
                  showTicketFilterModal: false,
                  ticketFilters: filters,
                });
              }
            }}
            onDismiss={() => this.setState({ showTicketFilterModal: false })}
          />
        </HomeTemplate>
      );
    }
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showToast: toastOperations.show,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(Finances);
